import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "currentColor" }, [
      _createElementVNode("path", { d: "M8.402 13.859c-1.324 0-2.402-1-2.402-2.224V9.014l1.034.922c.313.29.82.29 1.132 0a.704.704 0 0 0 0-1.048l-2.4-2.224a.846.846 0 0 0-1.132 0l-2.4 2.224a.704.704 0 0 0 0 1.048c.313.29.82.29 1.132 0L4.4 9.014v2.621c0 2.042 1.794 3.706 4.002 3.706h3.196V13.86H8.402M17.766 7.405a.845.845 0 0 0-1.132 0l-1.034.923V5.709C15.6 3.657 13.81 2 11.598 2H8.402v1.482h3.196c1.329 0 2.402.994 2.402 2.227v2.619l-1.034-.923a.845.845 0 0 0-1.132 0 .703.703 0 0 0 0 1.048l2.4 2.224c.313.29.82.29 1.132 0l2.4-2.224a.703.703 0 0 0 0-1.048" })
    ], -1)
  ]))]))
}
export default { render: render }